// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true, es9:true*/
(function(){
const is_node = !!(typeof module=='object' && module.exports);
const define = !is_node ? self.define
    : require('../../../util/require_node.js').define(module, '..');
define(['/util/country.js', 'lodash4'],
    (zcountry, _)=>
{
const E = {t: {}};

E.get_regions = country=>{
    if (!country)
        return [];
    country = zcountry.www2code(country.toUpperCase());
    if (!E.country_regions[country])
        return [];
    return Object.values(E.country_regions[country]);
};

E.region_to_sf_state = (region_code, country_code)=>{
    if (!region_code || !country_code)
        return null;
    let region_obj = E.regions.find(r=>r.country_code==country_code
        && r.region_code==region_code);
    return region_obj?.sf_region_code || null;
};

E.sf_state_to_region = (state_code, country_code)=>{
    if (!state_code || !country_code)
        return null;
    let region_obj = E.regions.find(r=>r.country_code==country_code
        && r.sf_region_code==state_code);
    return region_obj?.region_code || null;
};

// -- reference data --

E.zcountry_blacklist = [...Object.keys(zcountry.non_iso), 'AQ'];

E.countries = _.omit(zcountry.list, E.zcountry_blacklist);

/* eslint-disable */
E.regions = [
    // AU
    ['AU', 'ACT', 'ACT', 'Australian Capital Territory'],
    ['AU', 'NSW', 'NSW', 'New South Wales'],
    ['AU', 'NT', 'NT', 'Northern Territory'],
    ['AU', 'QLD', 'QLD', 'Queensland'],
    ['AU', 'SA', 'SA', 'South Australia'],
    ['AU', 'TAS', 'TAS', 'Tasmania'],
    ['AU', 'VIC', 'VIC', 'Victoria'],
    ['AU', 'WA', 'WA', 'Western Australia'],
    // BR
    ['BR', 'AC', 'AC', 'Acre'],
    ['BR', 'AL', 'AL', 'Alagoas'],
    ['BR', 'AM', 'AM', 'Amazonas'],
    ['BR', 'AP', 'AP', 'Amapa'],
    ['BR', 'BA', 'BA', 'Bahia'],
    ['BR', 'CE', 'CE', 'Ceara'],
    ['BR', 'DF', 'DF', 'Federal District'],
    ['BR', 'ES', 'ES', 'Espirito Santo'],
    ['BR', 'GO', 'GO', 'Goias'],
    ['BR', 'MA', 'MA', 'Maranhao'],
    ['BR', 'MG', 'MG', 'Minas Gerais'],
    ['BR', 'MS', 'MS', 'Mato Grosso do Sul'],
    ['BR', 'MT', 'MT', 'Mato Grosso'],
    ['BR', 'PA', 'PA', 'Para'],
    ['BR', 'PB', 'PB', 'Paraíba'],
    ['BR', 'PE', 'PE', 'Pernambuco'],
    ['BR', 'PI', 'PI', 'Piaui'],
    ['BR', 'PR', 'PR', 'Parana'],
    ['BR', 'RJ', 'RJ', 'Rio de Janeiro'],
    ['BR', 'RN', 'RN', 'Rio Grande do Norte'],
    ['BR', 'RO', 'RO', 'Rondonia'],
    ['BR', 'RR', 'RR', 'Roraima'],
    ['BR', 'RS', 'RS', 'Rio Grande do Sul'],
    ['BR', 'SC', 'SC', 'Santa Catarina'],
    ['BR', 'SE', 'SE', 'Sergipe'],
    ['BR', 'SP', 'SP', 'Sao Paulo'],
    ['BR', 'TO', 'TO', 'Tocantins'],
    // CA
    ['CA', 'AB', 'AB', 'Alberta'],
    ['CA', 'BC', 'BC', 'British Columbia'],
    ['CA', 'MB', 'MB', 'Manitoba'],
    ['CA', 'NB', 'NB', 'New Brunswick'],
    ['CA', 'NL', 'NL', 'Newfoundland and Labrador'],
    ['CA', 'NS', 'NS', 'Nova Scotia'],
    ['CA', 'NT', 'NT', 'Northwest Territories'],
    ['CA', 'NU', 'NU', 'Nunavut'],
    ['CA', 'ON', 'ON', 'Ontario'],
    ['CA', 'PE', 'PE', 'Prince Edward Island'],
    ['CA', 'QC', 'QC', 'Quebec'],
    ['CA', 'SK', 'SK', 'Saskatchewan'],
    ['CA', 'YT', 'YT', 'Yukon'],
    // CN
    ['CN', 'AH', '34', 'Anhui'],
    ['CN', 'BJ', '11', 'Beijing'],
    ['CN', 'CQ', '50', 'Chongqing'],
    ['CN', 'FJ', '35', 'Fujian'],
    ['CN', 'GD', '44', 'Guangdong'],
    ['CN', 'GS', '62', 'Gansu'],
    ['CN', 'GX', '45', 'Guangxi'],
    ['CN', 'GZ', '52', 'Guizhou'],
    ['CN', 'HA', '41', 'Henan'],
    ['CN', 'HB', '42', 'Hubei'],
    ['CN', 'HE', '13', 'Hebei'],
    ['CN', 'HI', '46', 'Hainan'],
    ['CN', 'HL', '23', 'Heilongjiang'],
    ['CN', 'HN', '43', 'Hunan'],
    ['CN', 'JL', '22', 'Jilin'],
    ['CN', 'JS', '32', 'Jiangsu'],
    ['CN', 'JX', '36', 'Jiangxi'],
    ['CN', 'LN', '21', 'Liaoning'],
    ['CN', 'NM', 'NM', 'Inner Mongolia Autonomous Region'],
    ['CN', 'NX', '64', 'Ningxia Hui Autonomous Region'],
    ['CN', 'QH', '63', 'Qinghai'],
    ['CN', 'SC', '51', 'Sichuan'],
    ['CN', 'SD', '37', 'Shandong'],
    ['CN', 'SH', '31', 'Shanghai'],
    ['CN', 'SN', '61', 'Shaanxi'],
    ['CN', 'SX', '14', 'Shanxi'],
    ['CN', 'TJ', '12', 'Tianjin'],
    ['CN', 'XJ', '65', 'Xinjiang Uyghur Autonomous Region'],
    ['CN', 'XZ', 'XZ', 'Tibet'],
    ['CN', 'YN', '53', 'Yunnan'],
    ['CN', 'ZJ', '33', 'Zhejiang'],
    // GB
    ['GB', 'ENG', 'ENG', 'England'],
    ['GB', 'NIR', 'NIR', 'Northern Ireland'],
    ['GB', 'SCT', 'SCT', 'Scotland'],
    ['GB', 'WLS', 'WLS', 'Wales'],
    // IE
    ['IE', 'CE', 'CE', 'Clare'],
    ['IE', 'CN', 'CN', 'Cavan'],
    ['IE', 'CO', 'CO', 'Cork'],
    ['IE', 'CW', 'CW', 'Carlow'],
    ['IE', 'D', 'D', 'Dublin'],
    ['IE', 'DL', 'DL', 'Donegal'],
    ['IE', 'G', 'G', 'Galway'],
    ['IE', 'KE', 'KE', 'Kildare'],
    ['IE', 'KK', 'KK', 'Kilkenny'],
    ['IE', 'KY', 'KY', 'Kerry'],
    ['IE', 'LD', 'LD', 'Longford'],
    ['IE', 'LH', 'LH', 'Louth'],
    ['IE', 'LK', 'LK', 'Limerick'],
    ['IE', 'LM', 'LM', 'Leitrim'],
    ['IE', 'LS', 'LS', 'Laois'],
    ['IE', 'MH', 'MH', 'Meath'],
    ['IE', 'MN', 'MN', 'Monaghan'],
    ['IE', 'MO', 'MO', 'Mayo'],
    ['IE', 'OY', 'OY', 'Offaly'],
    ['IE', 'RN', 'RN', 'Roscommon'],
    ['IE', 'SO', 'SO', 'Sligo'],
    ['IE', 'TA', 'TA', 'Tipperary'],
    ['IE', 'WD', 'WD', 'Waterford'],
    ['IE', 'WH', 'WH', 'Westmeath'],
    ['IE', 'WW', 'WW', 'Wicklow'],
    ['IE', 'WX', 'WX', 'Wexford'],
    // IL
    ['IL', 'D', 'D', 'Southern District',
        {labels: ['South District']}],
    ['IL', 'HA', 'HA', 'Haifa',
        {labels: ['Haifa District']}],
    ['IL', 'JM', 'JM', 'Jerusalem',
        {labels: ['Jerusalem District']}],
    ['IL', 'M', 'M', 'Central District',
        {labels: ['Center District']}],
    ['IL', 'TA', 'TA', 'Tel Aviv',
        {labels: ['Tel Aviv District']}],
    ['IL', 'Z', 'Z', 'Northern District',
        {labels: ['North District']}],
    // IN
    ['IN', 'AN', 'AN', 'Andaman and Nicobar'],
    ['IN', 'AP', 'AP', 'Andhra Pradesh'],
    ['IN', 'AR', 'AR', 'Arunachal Pradesh'],
    ['IN', 'AS', 'AS', 'Assam'],
    ['IN', 'BR', 'BR', 'Bihar'],
    ['IN', 'CH', 'CH', 'Chandigarh'],
    ['IN', 'CT', 'CT', 'Chhattisgarh'],
    ['IN', 'DN', 'DN', 'Dadra and Nagar Haveli'],
    ['IN', 'DD', 'DD', 'Daman and Diu'],
    ['IN', 'DL', 'DL', 'National Capital Territory of Delhi'],
    ['IN', 'GA', 'GA', 'Goa'],
    ['IN', 'GJ', 'GJ', 'Gujarat'],
    ['IN', 'HP', 'HP', 'Himachal Pradesh'],
    ['IN', 'HR', 'HR', 'Haryana'],
    ['IN', 'JH', 'JH', 'Jharkhand'],
    ['IN', 'JK', 'JK', 'Jammu and Kashmir'],
    ['IN', 'KA', 'KA', 'Karnataka'],
    ['IN', 'KL', 'KL', 'Kerala'],
    ['IN', 'LD', 'LD', 'Lakshadweep'],
    ['IN', 'MH', 'MH', 'Maharashtra'],
    ['IN', 'ML', 'ML', 'Meghalaya'],
    ['IN', 'MN', 'MN', 'Manipur'],
    ['IN', 'MP', 'MP', 'Madhya Pradesh'],
    ['IN', 'MZ', 'MZ', 'Mizoram'],
    ['IN', 'NL', 'NL', 'Nagaland'],
    ['IN', 'OR', 'OR', 'Odisha'],
    ['IN', 'PB', 'PB', 'Punjab'],
    ['IN', 'PY', 'PY', 'Union Territory of Puducherry'],
    ['IN', 'RJ', 'RJ', 'Rajasthan'],
    ['IN', 'SK', 'SK', 'Sikkim'],
    ['IN', 'TG', 'TG', 'Telangana'],
    ['IN', 'TN', 'TN', 'Tamil Nadu'],
    ['IN', 'TR', 'TR', 'Tripura'],
    ['IN', 'UP', 'UP', 'Uttar Pradesh'],
    ['IN', 'UT', 'UT', 'Uttarakhand'],
    ['IN', 'WB', 'WB', 'West Bengal'],
    // IT
    ['IT', 'AG', 'AG', 'Agrigento'],
    ['IT', 'AL', 'AL', 'Alessandria'],
    ['IT', 'AN', 'AN', 'Ancona'],
    ['IT', 'AO', 'AO', 'Aosta'],
    ['IT', 'AP', 'AP', 'Ascoli Piceno'],
    ['IT', 'AQ', 'AQ', `L'Aquila`],
    ['IT', 'AR', 'AR', 'Arezzo'],
    ['IT', 'AT', 'AT', 'Asti'],
    ['IT', 'AV', 'AV', 'Avellino'],
    ['IT', 'BA', 'BA', 'Bari'],
    ['IT', 'BG', 'BG', 'Bergamo'],
    ['IT', 'BI', 'BI', 'Biella'],
    ['IT', 'BL', 'BL', 'Belluno'],
    ['IT', 'BN', 'BN', 'Benevento'],
    ['IT', 'BO', 'BO', 'Bologna'],
    ['IT', 'BR', 'BR', 'Brindisi'],
    ['IT', 'BS', 'BS', 'Brescia'],
    ['IT', 'BT', 'BT', 'Barletta-Andria-Trani'],
    ['IT', 'BZ', 'BZ', 'Bolzano'],
    ['IT', 'CA', 'CA', 'Cagliari'],
    ['IT', 'CB', 'CB', 'Campobasso'],
    ['IT', 'CE', 'CE', 'Caserta'],
    ['IT', 'CH', 'CH', 'Chieti'],
    ['IT', 'CI', 'CI', 'Carbonia-Iglesias'],
    ['IT', 'CL', 'CL', 'Caltanissetta'],
    ['IT', 'CN', 'CN', 'Cuneo'],
    ['IT', 'CO', 'CO', 'Como'],
    ['IT', 'CR', 'CR', 'Cremona'],
    ['IT', 'CS', 'CS', 'Cosenza'],
    ['IT', 'CT', 'CT', 'Catania'],
    ['IT', 'CZ', 'CZ', 'Catanzaro'],
    ['IT', 'EN', 'EN', 'Enna'],
    ['IT', 'FC', 'FC', 'Forlì-Cesena'],
    ['IT', 'FE', 'FE', 'Ferrara'],
    ['IT', 'FG', 'FG', 'Foggia'],
    ['IT', 'FI', 'FI', 'Florence'],
    ['IT', 'FM', 'FM', 'Fermo'],
    ['IT', 'FR', 'FR', 'Frosinone'],
    ['IT', 'GE', 'GE', 'Genoa'],
    ['IT', 'GO', 'GO', 'Gorizia'],
    ['IT', 'GR', 'GR', 'Grosseto'],
    ['IT', 'IM', 'IM', 'Imperia'],
    ['IT', 'IS', 'IS', 'Isernia'],
    ['IT', 'KR', 'KR', 'Crotone'],
    ['IT', 'LC', 'LC', 'Lecco'],
    ['IT', 'LE', 'LE', 'Lecce'],
    ['IT', 'LI', 'LI', 'Livorno'],
    ['IT', 'LO', 'LO', 'Lodi'],
    ['IT', 'LT', 'LT', 'Latina'],
    ['IT', 'LU', 'LU', 'Lucca'],
    ['IT', 'MB', 'MB', 'Monza and Brianza'],
    ['IT', 'MC', 'MC', 'Macerata'],
    ['IT', 'ME', 'ME', 'Messina'],
    ['IT', 'MI', 'MI', 'Milan'],
    ['IT', 'MN', 'MN', 'Mantua'],
    ['IT', 'MO', 'MO', 'Modena'],
    ['IT', 'MS', 'MS', 'Massa and Carrara'],
    ['IT', 'MT', 'MT', 'Matera'],
    ['IT', 'NA', 'NA', 'Naples'],
    ['IT', 'NO', 'NO', 'Novara'],
    ['IT', 'NU', 'NU', 'Nuoro'],
    ['IT', 'OG', 'OG', 'Ogliastra'],
    ['IT', 'OR', 'OR', 'Oristano'],
    ['IT', 'OT', 'OT', 'Olbia-Tempio'],
    ['IT', 'PA', 'PA', 'Palermo'],
    ['IT', 'PC', 'PC', 'Piacenza'],
    ['IT', 'PD', 'PD', 'Padua'],
    ['IT', 'PE', 'PE', 'Pescara'],
    ['IT', 'PG', 'PG', 'Perugia'],
    ['IT', 'PI', 'PI', 'Pisa'],
    ['IT', 'PN', 'PN', 'Pordenone'],
    ['IT', 'PO', 'PO', 'Prato'],
    ['IT', 'PR', 'PR', 'Parma'],
    ['IT', 'PT', 'PT', 'Pistoia'],
    ['IT', 'PU', 'PU', 'Pesaro and Urbino'],
    ['IT', 'PV', 'PV', 'Pavia'],
    ['IT', 'PZ', 'PZ', 'Potenza'],
    ['IT', 'RA', 'RA', 'Ravenna'],
    ['IT', 'RC', 'RC', 'Reggio Calabria'],
    ['IT', 'RE', 'RE', 'Reggio Emilia'],
    ['IT', 'RG', 'RG', 'Ragusa'],
    ['IT', 'RI', 'RI', 'Rieti'],
    ['IT', 'RM', 'RM', 'Rome'],
    ['IT', 'RN', 'RN', 'Rimini'],
    ['IT', 'RO', 'RO', 'Rovigo'],
    ['IT', 'SA', 'SA', 'Salerno'],
    ['IT', 'SI', 'SI', 'Siena'],
    ['IT', 'SO', 'SO', 'Sondrio'],
    ['IT', 'SP', 'SP', 'La Spezia'],
    ['IT', 'SR', 'SR', 'Syracuse'],
    ['IT', 'SS', 'SS', 'Sassari'],
    ['IT', 'SV', 'SV', 'Savona'],
    ['IT', 'TA', 'TA', 'Taranto'],
    ['IT', 'TE', 'TE', 'Teramo'],
    ['IT', 'TN', 'TN', 'Trento'],
    ['IT', 'TO', 'TO', 'Turin'],
    ['IT', 'TP', 'TP', 'Trapani'],
    ['IT', 'TR', 'TR', 'Terni'],
    ['IT', 'TS', 'TS', 'Trieste'],
    ['IT', 'TV', 'TV', 'Treviso'],
    ['IT', 'UD', 'UD', 'Udine'],
    ['IT', 'VA', 'VA', 'Varese'],
    ['IT', 'VB', 'VB', 'Verbano-Cusio-Ossola'],
    ['IT', 'VC', 'VC', 'Vercelli'],
    ['IT', 'VE', 'VE', 'Venice'],
    ['IT', 'VI', 'VI', 'Vicenza'],
    ['IT', 'VR', 'VR', 'Verona'],
    ['IT', 'VS', 'VS', 'Medio Campidano'],
    ['IT', 'VT', 'VT', 'Viterbo'],
    ['IT', 'VV', 'VV', 'Vibo Valentia'],
    // MX
    ['MX', 'AGU', 'AG', 'Aguascalientes'],
    ['MX', 'BCN', 'BC', 'Baja California'],
    ['MX', 'BCS', 'BS', 'Baja California Sur'],
    ['MX', 'CAM', 'CM', 'Campeche'],
    ['MX', 'CHH', 'CH', 'Chihuahua'],
    ['MX', 'CHP', 'CS', 'Chiapas'],
    ['MX', 'CMX', 'DF', 'Mexico City'],
    ['MX', 'COA', 'CO', 'Coahuila'],
    ['MX', 'COL', 'CL', 'Colima'],
    ['MX', 'DUR', 'DG', 'Durango'],
    ['MX', 'GRO', 'GR', 'Guerrero'],
    ['MX', 'GUA', 'GT', 'Guanajuato'],
    ['MX', 'HID', 'HG', 'Hidalgo'],
    ['MX', 'JAL', 'JA', 'Jalisco'],
    ['MX', 'MEX', 'ME', 'México'],
    ['MX', 'MIC', 'MI', 'Michoacán'],
    ['MX', 'MOR', 'MO', 'Morelos'],
    ['MX', 'NAY', 'NA', 'Nayarit'],
    ['MX', 'NLE', 'NL', 'Nuevo León'],
    ['MX', 'OAX', 'OA', 'Oaxaca'],
    ['MX', 'PUE', 'PB', 'Puebla'],
    ['MX', 'QUE', 'QE', 'Querétaro'],
    ['MX', 'ROO', 'QR', 'Quintana Roo'],
    ['MX', 'SIN', 'SI', 'Sinaloa'],
    ['MX', 'SLP', 'SL', 'San Luis Potosí'],
    ['MX', 'SON', 'SO', 'Sonora'],
    ['MX', 'TAB', 'TB', 'Tabasco'],
    ['MX', 'TAM', 'TM', 'Tamaulipas'],
    ['MX', 'TLA', 'TL', 'Tlaxcala'],
    ['MX', 'VER', 'VE', 'Veracruz'],
    ['MX', 'YUC', 'YU', 'Yucatán'],
    ['MX', 'ZAC', 'ZA', 'Zacatecas'],
    // US
    ['US', 'AK', 'AK', 'Alaska'],
    ['US', 'AL', 'AL', 'Alabama'],
    ['US', 'AR', 'AR', 'Arkansas'],
    ['US', 'AZ', 'AZ', 'Arizona'],
    ['US', 'CA', 'CA', 'California'],
    ['US', 'CO', 'CO', 'Colorado'],
    ['US', 'CT', 'CT', 'Connecticut'],
    ['US', 'DC', 'DC', 'District of Columbia'],
    ['US', 'DE', 'DE', 'Delaware'],
    ['US', 'FL', 'FL', 'Florida'],
    ['US', 'GA', 'GA', 'Georgia'],
    ['US', 'HI', 'HI', 'Hawaii'],
    ['US', 'IA', 'IA', 'Iowa'],
    ['US', 'ID', 'ID', 'Idaho'],
    ['US', 'IL', 'IL', 'Illinois'],
    ['US', 'IN', 'IN', 'Indiana'],
    ['US', 'KS', 'KS', 'Kansas'],
    ['US', 'KY', 'KY', 'Kentucky'],
    ['US', 'LA', 'LA', 'Louisiana'],
    ['US', 'MA', 'MA', 'Massachusetts'],
    ['US', 'MD', 'MD', 'Maryland'],
    ['US', 'ME', 'ME', 'Maine'],
    ['US', 'MI', 'MI', 'Michigan'],
    ['US', 'MN', 'MN', 'Minnesota'],
    ['US', 'MO', 'MO', 'Missouri'],
    ['US', 'MS', 'MS', 'Mississippi'],
    ['US', 'MT', 'MT', 'Montana'],
    ['US', 'NC', 'NC', 'North Carolina'],
    ['US', 'ND', 'ND', 'North Dakota'],
    ['US', 'NE', 'NE', 'Nebraska'],
    ['US', 'NH', 'NH', 'New Hampshire'],
    ['US', 'NJ', 'NJ', 'New Jersey'],
    ['US', 'NM', 'NM', 'New Mexico'],
    ['US', 'NV', 'NV', 'Nevada'],
    ['US', 'NY', 'NY', 'New York'],
    ['US', 'OH', 'OH', 'Ohio'],
    ['US', 'OK', 'OK', 'Oklahoma'],
    ['US', 'OR', 'OR', 'Oregon'],
    ['US', 'PA', 'PA', 'Pennsylvania'],
    ['US', 'RI', 'RI', 'Rhode Island'],
    ['US', 'SC', 'SC', 'South Carolina'],
    ['US', 'SD', 'SD', 'South Dakota'],
    ['US', 'TN', 'TN', 'Tennessee'],
    ['US', 'TX', 'TX', 'Texas'],
    ['US', 'UT', 'UT', 'Utah'],
    ['US', 'VA', 'VA', 'Virginia'],
    ['US', 'VT', 'VT', 'Vermont'],
    ['US', 'WA', 'WA', 'Washington'],
    ['US', 'WI', 'WI', 'Wisconsin'],
    ['US', 'WV', 'WV', 'West Virginia'],
    ['US', 'WY', 'WY', 'Wyoming'],
    // UA
    // List: https://www.iso.org/obp/ui/#iso:code:3166:UA
    // Google: https://developers.google.com/google-ads/api/data/geotargets
    ['UA', '43', '43', 'Avtonomna Respublika Krym'], // NOTE, not in Google
    ['UA', '71', '71', 'Cherkasy Oblast', {labels: ['Cherkas\'ka oblast']}],
    ['UA', '74', '74', 'Chernihiv Oblast',
        {labels: ['Chernihivs\'ka oblast']}],
    ['UA', '77', '77', 'Chernivtsi Oblast',
        {labels: ['Chernivets\'ka oblast']}],
    ['UA', '12', '12', 'Dnipropetrovsk Oblast',
        {labels: ['Dnipropetrovs\'ka oblast']}],
    ['UA', '14', '14', 'Donetsk Oblast', {labels: ['Donets\'ka oblast']}],
    ['UA', '26', '26', 'Ivano-Frankivsk Oblast',
        {labels: ['Ivano-Frankivs\'ka oblast']}],
    ['UA', '63', '63', 'Kharkiv Oblast', {labels: ['Kharkivs\'ka oblast']}],
    ['UA', '65', '65', 'Kherson Oblast', {labels: ['Khersons\'ka oblast']}],
    ['UA', '68', '68', 'Khmelnytskyi Oblast',
        {labels: ['Khmel\'nyts\'ka oblast']}],
    ['UA', '35', '35', 'Kirovohrad Oblast',
        {labels: ['Kirovohrads\'ka oblast']}],
    ['UA', '30', '30', 'Kyiv', {labels: ['Kyiv city', 'місто Київ']}],
    ['UA', '32', '32', 'Kyiv Oblast', {labels: ['Kyivs\'ka oblast']}],
    ['UA', '09', '09', 'Luhansk Oblast', {labels: ['Luhans\'ka oblast']}],
    ['UA', '46', '46', 'Lviv Oblast', {labels: ['L\'vivs\'ka oblast']}],
    ['UA', '48', '48', 'Mykolaiv Oblast', {labels: ['Mykolaivs\'ka oblast']}],
    ['UA', '51', '51', 'Odesa Oblast', {labels: ['Odes\'ka oblast']}],
    ['UA', '53', '53', 'Poltava Oblast', {labels: ['Poltavs\'ka oblast']}],
    ['UA', '56', '56', 'Rivne Oblast', {labels: ['Rivnens\'ka oblast']}],
    ['UA', '40', '40', 'Sevastopol'],
    ['UA', '59', '59', 'Sumy Oblast', {labels: ['Sums\'ka oblast']}],
    ['UA', '61', '61', 'Ternopil Oblast',
        {labels: ['Ternopil\'s\'ka oblast']}],
    ['UA', '05', '05', 'Vinnytsia Oblast',
        {labels: ['Vinnyts\'ka oblast']}],
    ['UA', '07', '07', 'Volyn Oblast', {labels: ['Volyns\'ka oblast']}],
    ['UA', '21', '21', 'Zakarpattia Oblast',
        {labels: ['Zakarpats\'ka oblast']}],
    ['UA', '23', '23', 'Zaporizhia Oblast',
        {labels: ['Zaporiz\'ka oblast']}],
    ['UA', '18', '18', 'Zhytomyr Oblast', {labels: ['Zhytomyrs\'ka oblast']}],
    // RU
    // List: https://www.iso.org/obp/ui/#iso:code:3166:RU
    // Google: https://developers.google.com/google-ads/api/data/geotargets
    ['RU', 'AD', 'AD', 'Adygea Republic',
        {labels: ['Respublika Adygeya']}],
    ['RU', 'AL', 'AL', 'Altai Republic'],
    ['RU', 'ALT', 'ALT', 'Altai Krai',
        {labels: ['Altayskiy kray']}],
    ['RU', 'AMU', 'AMU', 'Amur Oblast',
        {labels: ['Amurskaya oblast\'']}],
    ['RU', 'ARK', 'ARK', 'Arkhangelsk Oblast',
        {labels: ['Arkhangelskaya oblast\'']}],
    ['RU', 'AST', 'AST', 'Astrakhan Oblast',
        {labels: ['Astrakhanskaya oblast\'']}],
    ['RU', 'BA', 'BA', 'Republic of Bashkortostan',
        {labels: ['Respublika Bashkortostan']}],
    ['RU', 'BEL', 'BEL', 'Belgorod Oblast',
        {labels: ['Belgorodskaya oblast\'']}],
    ['RU', 'BRY', 'BRY', 'Bryansk Oblast', {labels: ['Bryanskaya oblast\'']}],
    ['RU', 'BU', 'BU', 'Buryatia', {labels: ['Respublika Buryatiya']}],
    ['RU', 'CE', 'CE', 'Chechnya',
        {labels: ['Chechénskaya Respúblika']}],
    ['RU', 'CHE', 'CHE', 'Chelyabinsk Oblast',
        {labels: ['Chelyabinskaya oblast\'']}],
    ['RU', 'CHU', 'CHU', 'Chukotka Autonomous Okrug'],
    ['RU', 'CU', 'CU', 'Chuvashia Republic', {labels: ['Chuvashia']}],
    ['RU', 'DA', 'DA', 'Republic of Dagestan',
        {labels: ['Respublika Dagestan']}],
    ['RU', 'IN', 'IN', 'Ingushetia',
        {labels: ['Respublika Ingushetiya']}],
    ['RU', 'IRK', 'IRK', 'Irkutsk Oblast',
        {labels: ['Irkutskaya oblast\'']}],
    ['RU', 'IVA', 'IVA', 'Ivanovo Oblast', {labels: ['Ivanovskaya oblast\'']}],
    ['RU', 'KB', 'KB', 'Kabardino-Balkarian Republic',
        {labels: ['Kabardino-Balkarskaya Respublika']}],
    ['RU', 'KGD', 'KGD', 'Kaliningrad Oblast',
        {labels: ['Kaliningradskaya oblast\'']}],
    ['RU', 'KL', 'KL', 'Republic of Kalmykia',
        {labels: ['Respublika Kalmykiya']}],
    ['RU', 'KLU', 'KLU', 'Kaluga Oblast',
        {labels: ['Kaluzhskaya oblast\'']}],
    ['RU', 'KAM', 'KAM', 'Kamchatka Krai'],
    ['RU', 'KC', 'KC', 'Karachay-Cherkessia'],
    ['RU', 'KR', 'KR', 'Republic of Karelia',
        {labels: ['Respublika Kareliya']}],
    ['RU', 'KEM', 'KEM', 'Kemerovo Oblast',
        {labels: ['Kemerovskaya oblast\'']}],
    ['RU', 'KHA', 'KHA', 'Khabarovsk Krai',
        {labels: ['Khabarovskiy kray']}],
    ['RU', 'KK', 'KK', 'Republic of Khakassia',
        {labels: ['Respúblika Khakásiya']}],
    ['RU', 'KHM', 'KHM', 'Khanty-Mansi Autonomous Okrug', {labels: ['ХМАО']}],
    ['RU', 'KIR', 'KIR', 'Kirov Oblast',
        {labels: ['Kirovskaya oblast\'']}],
    ['RU', 'KO', 'KO', 'Komi Republic'],
    ['RU', 'KOS', 'KOS', 'Kostroma Oblast'],
    ['RU', 'KDA', 'KDA', 'Krasnodar Krai', {labels: ['Krasnodarskiy kray']}],
    ['RU', 'KYA', 'KYA', 'Krasnoyarsk Krai', {labels: ['Krasnoyarskiy kray']}],
    ['RU', 'KGN', 'KGN', 'Kurgan Oblast'],
    ['RU', 'KRS', 'KRS', 'Kursk Oblast'],
    ['RU', 'LEN', 'LEN', 'Leningrad Oblast',
        {labels: ['Leningradskaya oblast\'']}],
    ['RU', 'LIP', 'LIP', 'Lipetsk Oblast',
        {labels: ['Lipetskaya oblast\'']}],
    ['RU', 'MAG', 'MAG', 'Magadan Oblast'],
    ['RU', 'ME', 'ME', 'Mari El Republic',
        {labels: ['Respublika Mariy El']}],
    ['RU', 'MO', 'MO', 'Mordovia Republic',
        {labels: ['Respublika Mordoviya']}],
    ['RU', 'MOS', 'MOS', 'Moscow Oblast'],
    ['RU', 'MOW', 'MOW', 'Moscow', {labels: ['Moskva', 'МО']}],
    ['RU', 'MUR', 'MUR', 'Murmansk Oblast',
        {labels: ['Murmanskaya oblast\'']}],
    ['RU', 'NEN', 'NEN', 'Nenets Autonomous Okrug'],
    ['RU', 'NIZ', 'NIZ', 'Nizhny Novgorod Oblast',
        {labels: ['Nizhegorodskaya oblast\'']}],
    ['RU', 'NGR', 'NGR', 'Novgorod Oblast',
        {labels: ['Novgorodskaya oblast\'']}],
    ['RU', 'NVS', 'NVS', 'Novosibirsk Oblast',
        {labels: ['Novosibirskaya oblast\'']}],
    ['RU', 'OMS', 'OMS', 'Omsk Oblast', {labels: ['Omskaya oblast\'']}],
    ['RU', 'ORE', 'ORE', 'Orenburg Oblast',
        {labels: ['Orenburgskaya oblast\'']}],
    ['RU', 'ORL', 'ORL', 'Oryol Oblast', {labels: ['Orlovskaya oblast\'']}],
    ['RU', 'PNZ', 'PNZ', 'Penza Oblast', {labels: ['Penzenskaya oblast\'']}],
    ['RU', 'PER', 'PER', 'Perm Krai', {labels: ['Permskiy kray']}],
    ['RU', 'PRI', 'PRI', 'Primorsky Krai',
        {labels: ['Primorskiy kray']}],
    ['RU', 'PSK', 'PSK', 'Pskov Oblast',
        {labels: ['Pskovskaya oblast\'']}],
    ['RU', 'ROS', 'ROS', 'Rostov Oblast',
        {labels: ['Rostovskaya oblast\'']}],
    ['RU', 'RYA', 'RYA', 'Ryazan Oblast',
        {labels: ['Ryazanskaya oblast\'']}],
    ['RU', 'SA', 'SA', 'Sakha Republic',
        {labels: ['Respublika Sakha (Yakutiya)']}],
    ['RU', 'SAK', 'SAK', 'Sakhalin Oblast',
        {labels: ['Sakhalinskaya oblast\'']}],
    ['RU', 'SAM', 'SAM', 'Samara Oblast',
        {labels: ['Samarskaya oblast\'']}],
    ['RU', 'SPE', 'SPE', 'Saint Petersburg',
        {labels: ['Sankt-Peterburg']}],
    ['RU', 'SAR', 'SAR', 'Saratov Oblast',
        {labels: ['Saratovskaya oblast\'']}],
    ['RU', 'SE', 'SE', 'North Ossetia-Alania Republic',
        {labels: ['Respublika Severnaya Osetiya — Alaniya']}],
    ['RU', 'SMO', 'SMO', 'Smolensk Oblast',
        {labels: ['Smolenskaya oblast\'']}],
    ['RU', 'STA', 'STA', 'Stavropol Krai',
        {labels: ['Stavropolskiy kray']}],
    ['RU', 'SVE', 'SVE', 'Sverdlovsk Oblast',
        {labels: ['Sverdlovskaya oblast\'']}],
    ['RU', 'TAM', 'TAM', 'Tambov Oblast',
        {labels: ['Tambovskaya oblast\'']}],
    ['RU', 'TA', 'TA', 'Republic of Tatarstan',
        {labels: ['Respublika Tatarstan', 'Респ. Татарстан']}],
    ['RU', 'TOM', 'TOM', 'Tomsk Oblast', {labels: ['Tomskaya oblast\'']}],
    ['RU', 'TUL', 'TUL', 'Tula Oblast', {labels: ['Tulskaya oblast\'']}],
    ['RU', 'TVE', 'TVE', 'Tver Oblast', {labels: ['Tverskaya oblast\'']}],
    ['RU', 'TYU', 'TYU', 'Tyumen Oblast', {labels: ['Tyumenskaya oblast\'']}],
    ['RU', 'TY', 'TY', 'Tuva Republic'],
    ['RU', 'UD', 'UD', 'Udmurt Republic',
        {labels: ['Udmurtskaja Respublika']}],
    ['RU', 'ULY', 'ULY', 'Ulyanovsk Oblast',
        {labels: ['Ulyanovskaya oblast\'']}],
    ['RU', 'VLA', 'VLA', 'Vladimir Oblast',
        {labels: ['Vladimirskaya oblast\'']}],
    ['RU', 'VGG', 'VGG', 'Volgograd Oblast',
        {labels: ['Volgogradskaya oblast\'']}],
    ['RU', 'VLG', 'VLG', 'Vologda Oblast',
        {labels: ['Vologodskaya oblast\'']}],
    ['RU', 'VOR', 'VOR', 'Voronezh Oblast',
        {labels: ['Voronezhskaya oblast\'']}],
    ['RU', 'YAN', 'YAN', 'Yamalo-Nenets Autonomous Okrug',
        {labels: ['Ямало-Ненецкий Аутономус Область']}],
    ['RU', 'YAR', 'YAR', 'Yaroslavl Oblast',
        {labels: ['Yaroslavskaya oblast\'']}],
    ['RU', 'YEV', 'YEV', 'Jewish Autonomous Oblast',
        {labels: ['Еврейская Аутономус Область']}],
    ['RU', 'ZAB', 'ZAB', 'Zabaykalsky Krai'],
].map(([country_code, region_code, sf_region_code, label, addons={}])=>{
    return {country_code, region_code, sf_region_code, label, ...addons};
});
/* eslint-enable */

E.country_regions = E.regions.reduce((m, cr)=>{
    m[cr.country_code] = m[cr.country_code] || {};
    m[cr.country_code][cr.region_code] = {
        region: cr.label,
        r_id: cr.region_code,
        labels: cr.labels || [],
    };
    return m;
}, {});

E.get_country_region_by_label = (country, region)=>{
    let country_regions = E.country_regions[country];
    if (!country_regions)
        return null;
    return Object.values(country_regions).find(r=>{
        return r.r_id==region
            || r.region==region
            || r.labels.some(l=>l==region);
    });
};

return E; }); }()); // eslint-disable-line
